import React from 'react';
import { FormControlLabel, Grid, RadioGroup, TextField, Radio, FormLabel, FormHelperText } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';

const ModalAddEditUser = ({ open, isAdd, data, ctl, setCargando, setMensaje, handleClose, ...props }) => {
    const {
        register,
        control,
        formState: { errors }
    } = useFormContext();
    console.log(data);
    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <FormLabel sx={{ display: 'block', mb: 1 }}>Nombre del grupo</FormLabel>
                <TextField
                    label="Nombre *"
                    size="small"
                    fullWidth
                    {...register('nombre', { required: { value: true, message: 'Campo requerido' } })}
                    error={Boolean(errors.nombre)}
                    helperText={errors.nombre?.message}
                    defaultValue={data?.nombre}
                />
            </Grid>
            <Grid item xs={12}>
                <FormLabel sx={{ display: 'block', mb: 1 }}>Tipo de colaborador</FormLabel>
                <Controller
                    name="idTipoP"
                    control={control}
                    rules={{ required: 'Seleccione un tipo de colaborador' }}
                    defaultValue={data?.idTipoP || ''}
                    render={({ field }) => (
                        <RadioGroup row aria-label="Tipo Personal" {...field}>
                            <FormControlLabel value="1" control={<Radio sx={{ '&.Mui-checked': { color: '#1976d2' } }} />} label="Ventas" />
                            <FormControlLabel
                                value="2"
                                control={<Radio sx={{ '&.Mui-checked': { color: '#1976d2' } }} />}
                                label="Administrativo"
                            />
                        </RadioGroup>
                    )}
                />
                <FormHelperText style={{ color: '#FF4F4F' }}>{errors.idTipoP?.message}</FormHelperText>
            </Grid>
        </Grid>
    );
};

export default ModalAddEditUser;
